module.exports = __webpack_public_path__ + "img/flag.c99de1ea.svg";